<template>
  <div class="dot ms-1 mb-1 align-middle d-inline-flex align-items-center justify-content-center">
    <div v-if="actionCount">
      {{ actionCount }}
    </div>
  </div>
</template>

<script>

export default {
  props: {
    actionCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
  },
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="scss">

.dot {
  height: 1.25em;
  width: 1.25em;
  background-color: #FF3366;
  color: #FFF;
  border-radius: 50%;
  display: inline-block;
  p {
    text-align: center;
    font-size: 1rem;
    font-weight: bold;
  }
}
</style>
